const config = {
    version: '0.0.3',
    versionDate: '27/10/2021'
}

export default config


// WEBPACK FOOTER //
// ./src/mixins/config.js